import React from 'react';
import {Link} from 'react-router-dom';
import '../styling/home-return-link.css';

export default function HomeReturnLink() {
    return (
        <Link
            className="home-return-link"
            to="/"
            aria-label="Return to the Xenkia home page"
            onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'auto'})}
        >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="m3.75 10.5 8.25-7 8.25 7" />
                <path d="M5.75 9.25v10h12.5v-10M9.5 19.25v-6h5v6" />
            </svg>
            <span>Back to home</span>
        </Link>
    );
}
